import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          background: '#0a0a0a', minHeight: '100vh', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontFamily: "'DM Sans',-apple-system,sans-serif", padding: 24,
        }}>
          <div style={{ textAlign: 'center', maxWidth: 400 }}>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#f0f0f0', margin: '0 0 12px' }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: 14, color: '#777', margin: '0 0 32px', lineHeight: 1.65 }}>
              An unexpected error occurred. Please refresh the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '13px 32px', background: '#4EDEA3', color: '#000',
                border: 'none', borderRadius: 10, fontWeight: 800, fontSize: 14,
                cursor: 'pointer', letterSpacing: '0.02em',
                boxShadow: '0 0 20px rgba(78,222,163,0.3)',
              }}
            >
              Refresh page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
